import { StylesDerivedNativeActionNames } from '../../types';
import { StylesDerivedNativeActions } from '@wix/editor-platform-host-integration-apis';

export const BUILDER_TYPE = 'odeditor';
export const COMPONENT_CHANGE_EVENT_ID = 1399;
export const COMPONENT_CHANGE_SRC = 110;
export const CONTROL_TYPE_PLACEHOLDER = 'numeric_input';
export const CONTROL_ID_PLACEHOLDER = 'design_all';
export const PANEL_TYPE = 'mini_panel';
export const PANEL_BUILDER = 'automatic_panels_global';
export const PRODUCT_NAME = 'global design';
export const BACK_BUTTON_NAME = 'back';

export enum CONTAINER_NAME_TYPE {
  PANEL = 'PANEL',
  LOBBY = 'LOBBY',
}

export const PRESET_CONTROL_TYPE = 'preset_button';

export const PRESET_CONTROL_ID_BY_ACTION: Partial<
  Record<StylesDerivedNativeActionNames, string>
> = {
  [StylesDerivedNativeActions.cornerStyles]: 'design_all_corners_radius_size',
  [StylesDerivedNativeActions.shadowStyles]: 'design_box_shadow_blur',
  [StylesDerivedNativeActions.filterStyles]: 'design_all_filter_blur',
};

export const LOBBY_ITEM_BUTTON_NAME_BY_ACTION: Partial<
  Record<StylesDerivedNativeActionNames, string>
> = {
  [StylesDerivedNativeActions.textStyles]: 'lobby - text style click',
  [StylesDerivedNativeActions.borderStyles]: 'lobby - borders style click',
  [StylesDerivedNativeActions.cornerStyles]: 'lobby - corners style click',
  [StylesDerivedNativeActions.shadowStyles]: 'lobby - shadow style click',
  [StylesDerivedNativeActions.filterStyles]: 'lobby - filter style click',
  [StylesDerivedNativeActions.strokeStyles]: 'lobby - stroke style click',
};

export const CONTAINER_NAME_LOBBY_BY_ACTION: {
  [CONTAINER_NAME_TYPE.PANEL]: Partial<
    Record<StylesDerivedNativeActionNames, string>
  >;
  [CONTAINER_NAME_TYPE.LOBBY]: Partial<
    Record<StylesDerivedNativeActionNames, string>
  >;
} = {
  [CONTAINER_NAME_TYPE.PANEL]: {
    [StylesDerivedNativeActions.textStyles]: 'global design - text panel',
    [StylesDerivedNativeActions.borderStyles]: 'global design - borders panel',
    [StylesDerivedNativeActions.cornerStyles]: 'global design - corners panel',
    [StylesDerivedNativeActions.shadowStyles]: 'global design - shadow panel',
    [StylesDerivedNativeActions.filterStyles]: 'global design - filter panel',
    [StylesDerivedNativeActions.strokeStyles]: 'global design - stroke panel',
  },
  [CONTAINER_NAME_TYPE.LOBBY]: {
    [StylesDerivedNativeActions.textStyles]: 'global design - text panel lobby',
    [StylesDerivedNativeActions.borderStyles]:
      'global design - borders panel lobby',
    [StylesDerivedNativeActions.cornerStyles]:
      'global design - corners panel lobby',
    [StylesDerivedNativeActions.shadowStyles]:
      'global design - shadow panel lobby',
    [StylesDerivedNativeActions.filterStyles]:
      'global design - filter panel lobby',
    [StylesDerivedNativeActions.strokeStyles]:
      'global design - stroke panel lobby',
  },
};

export const PANEL_NAME_BY_ACTION: Partial<
  Record<StylesDerivedNativeActionNames, string>
> = {
  [StylesDerivedNativeActions.textStyles]: 'global_text_panel',
  [StylesDerivedNativeActions.borderStyles]: 'global_borders_panel',
  [StylesDerivedNativeActions.cornerStyles]: 'global_corners_panel',
  [StylesDerivedNativeActions.shadowStyles]: 'global_shadow_panel',
  [StylesDerivedNativeActions.spacingStyles]: 'global_spacing_panel',
  [StylesDerivedNativeActions.filterStyles]: 'global_filter_panel',
  [StylesDerivedNativeActions.strokeStyles]: 'global_stroke_panel',
};
